import SignInForm from "@/components/common/signin-form";
import SignUpForm from "@/components/common/signup-form";
import SocialLoginButton from "@/components/shared/social-login-button";
import Modal from "@/components/ui/modal";
import { cn } from "@/lib/utils";
import { Tab } from "@headlessui/react";
import Image from "next/image";
import { signIn } from "next-auth/react";

type AuthModalProps = {
	isOpen: boolean;
	onClose: () => void;
	onAuthSuccess?: () => void;
};

const providers = [
	{ provider: "google", imageUrl: "/images/auth-providers/google.png" },
	{ provider: "linkedin", imageUrl: "/images/auth-providers/linkedin.png" },
	{ provider: "twitter", imageUrl: "/images/auth-providers/x.png" },
];

function AuthModal({ isOpen, onClose, onAuthSuccess }: AuthModalProps) {
	const handleSuccess = () => {
		onClose();
		onAuthSuccess?.();
	};

	const handleSocialLogin = (provider: string) => {
		signIn(provider);
	};

	return (
		<Modal isOpen={isOpen} onClose={onClose} className="max-w-md px-4 pb-4 pt-2">
			<div className="mb-2 flex h-36 w-full items-center justify-center rounded-lg bg-gradient-to-r from-brand-primary/5 via-brand-primary/20 to-brand-primary/5 py-2">
				<Image
					src="/images/proptechbuzz-logo.svg"
					alt="PropTechBuzz Logo"
					width={48}
					height={48}
					className="h-full w-48 fill-[#271B58]"
				/>
			</div>
			<Tab.Group>
				<Tab.List className="flex space-x-1 rounded-lg bg-brand-primary p-1">
					<Tab
						className={({ selected }) =>
							cn(
								"w-full rounded-lg py-2.5 text-sm font-medium leading-5",
								selected ? "bg-white text-brand-primary" : "text-white"
							)
						}
					>
						Sign Up
					</Tab>
					<Tab
						className={({ selected }) =>
							cn(
								"w-full rounded-lg py-2.5 text-sm font-medium leading-5",
								selected ? "bg-white text-brand-primary" : "text-white"
							)
						}
					>
						Sign In
					</Tab>
				</Tab.List>
				<Tab.Panels className="mt-4">
					<Tab.Panel>
						<SignUpForm onSuccess={handleSuccess} />

						<div className="space-y-2 pt-2">
							<div className="flex items-center gap-2.5">
								<p className="whitespace-nowrap text-sm text-gray-600">
									or <span className="font-semibold">Sign up using</span>
								</p>
								<div className="flex-1 border-t border-gray-300"></div>
							</div>

							<div className="flex gap-3">
								{providers.map((item) => (
									<SocialLoginButton
										key={item.provider}
										provider={item.provider}
										imageUrl={item.imageUrl}
										onClick={() => handleSocialLogin(item.provider)}
									/>
								))}
							</div>
						</div>
					</Tab.Panel>
					<Tab.Panel>
						<SignInForm />

						<div className="space-y-2 pt-2">
							<div className="flex items-center gap-2.5">
								<p className="whitespace-nowrap text-sm text-gray-600">
									or <span className="font-semibold">Sign in using</span>
								</p>
								<div className="flex-1 border-t border-gray-300"></div>
							</div>

							<div className="flex gap-3">
								{providers.map((item) => (
									<SocialLoginButton
										key={item.provider}
										provider={item.provider}
										imageUrl={item.imageUrl}
										onClick={() => handleSocialLogin(item.provider)}
									/>
								))}
							</div>
						</div>
					</Tab.Panel>
				</Tab.Panels>
			</Tab.Group>
		</Modal>
	);
}

export default AuthModal;
